import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      gap: theme.spacing(1),
      color: COLORS.neutral.secondary,
    },
    text: {
      color: COLORS.gray.black,
    },
  }),
  { name: 'UnauthenticatedPageFooterTextLink' }
);
